import React, { useState, useEffect } from 'react'
import TimerWidget from '../../UI/TimerWidget'


const TimerCard = ({ getDataFromChild, dateFromParent, setBlankDate, onFocus }) => {

    const [date, setDate] = useState(dateFromParent || new Date());
    const [dateString, setDateString] = useState('');
    useEffect(() => {
        const d = dateFromParent || new Date();
        setDate(d);
        let str = `${d.getHours()}_${d.getMinutes()}_${d.getSeconds()}`
        setDateString(str);
        setBlankDate && setBlankDate(str);
    }, [dateFromParent, setBlankDate]);

    const handleTimerCB = (data, type) => {
        let arr = dateString.split("_");
        let temp = data.toString().length;
        let correctDigit = "";
        if (temp === 1) {
            correctDigit = "0" + data.toString();
        } else {
            correctDigit = data.toString();
        }

        if (type === "HOUR") {
            arr[0] = correctDigit;
        } else if (type === "MIN") {
            arr[1] = correctDigit;
        } else {
            arr[2] = correctDigit;
        }
        setDateString(arr.join("_"));
        getDataFromChild(arr.join("_"));
    }

    return (
        <div className='popup_body' style={{ gap: "0.3rem", display: 'flex', alignItems: 'center', cursor: onFocus ? 'pointer' : 'default' }} onClick={() => onFocus && onFocus()}>
            <TimerWidget key={`h-${date.getTime()}`} maxCount={23} handleTimerCB={handleTimerCB} type="HOUR"
                min="00"
                max="23"
                maxLength="2"
                defaultValue={date.getHours()}
                onFocus={() => onFocus && onFocus()}
            />
            :
            <TimerWidget key={`m-${date.getTime()}`} maxCount={59} handleTimerCB={handleTimerCB} type="MIN"
                min="00"
                max="59"
                maxLength="2"
                defaultValue={date.getMinutes()}
                onFocus={() => onFocus && onFocus()}
            />
            :
            <TimerWidget key={`s-${date.getTime()}`} maxCount={59} handleTimerCB={handleTimerCB} type="SEC"
                min="00"
                max="59"
                maxLength="2"
                defaultValue={date.getSeconds()}
                onFocus={() => onFocus && onFocus()}
            />
        </div>
    )
}

export default TimerCard